import React from 'react';
import PropTypes from 'prop-types';
import * as yup from 'yup';

import BotMessage from '../components/BotMessage';
import UserMessage from '../components/UserMessage';
import InputLink from '../components/InputLink';

const UserMessage1 = props => (
  <UserMessage {...props} typeInput>
    Hi, my name is
  </UserMessage>
);

const BotMessage2 = ({ userName, ...rest }) => (
  <BotMessage {...rest}>
    Hi, {userName}
    <br />
    Let’s start a project?
  </BotMessage>
);
BotMessage2.propTypes = {
  userName: PropTypes.string.isRequired,
};

const UserMessage2 = props => (
  <UserMessage {...props}>
    Yeah! I want discuss <InputLink name="branding" />, <InputLink name="digital" />, <InputLink name="promo" /> or{' '}
    <InputLink name="all" />
  </UserMessage>
);

const BotMessage3 = props => <BotMessage {...props}>Ok. Tell us few words about the project.</BotMessage>;

const UserMessage3 = props => (
  <UserMessage {...props} typeInput>
    Some description
  </UserMessage>
);

const BotMessage4 = props => <BotMessage {...props}>Good. Tell me a budget for the project?</BotMessage>;

const UserMessage4 = props => (
  <UserMessage {...props}>
    Budget for the project <InputLink name="less $10.000" />, <InputLink name="less $20.000" />,{' '}
    <InputLink name="more $20.000" />
  </UserMessage>
);

const BotMessage5 = props => (
  <BotMessage {...props}>
    Sound good.
    <br />
    Tell me a deadline for the project.
  </BotMessage>
);

const UserMessage5 = props => (
  <UserMessage {...props} typeInput>
    Deadline is
  </UserMessage>
);

const BotMessage6 = props => (
  <BotMessage {...props}>
    Okay. Please, leave your
    <br />
    email to receive our answer.
  </BotMessage>
);

const UserMessage6 = props => (
  <UserMessage {...props} typeInput>
    My email is
  </UserMessage>
);

const steps = [
  {
    botMessage: {
      component: null,
    },
    userMessage: {
      component: UserMessage1,
    },
    valueKey: 'f_name',
    validation: yup.string().required(),
  },
  {
    botMessage: {
      component: BotMessage2,
    },
    userMessage: {
      component: UserMessage2,
    },
    valueKey: 'f_category',
    validation: yup.string().required(),
  },
  {
    botMessage: {
      component: BotMessage3,
    },
    userMessage: {
      component: UserMessage3,
    },
    valueKey: 'f_description',
    validation: yup.string().required(),
  },
  {
    botMessage: {
      component: BotMessage4,
    },
    userMessage: {
      component: UserMessage4,
    },
    valueKey: 'f_budget',
    validation: yup.string().required(),
  },
  {
    botMessage: {
      component: BotMessage5,
    },
    userMessage: {
      component: UserMessage5,
    },
    valueKey: 'f_deadline',
    validation: yup.string().required(),
  },
  {
    botMessage: {
      component: BotMessage6,
    },
    userMessage: {
      component: UserMessage6,
    },
    valueKey: 'f_email',
    validation: yup
      .string()
      .email()
      .required(),
  },
];

export default steps;



// WEBPACK FOOTER //
// ./src/scenes/Brief/components/BriefBot/lib/steps.js